import { IPuzzleV1 } from "./v1/interfaces/classes/IPuzzleV1";
import { IPlayerStat, IPlayerStats } from "./v1/interfaces/data/IPlayerStats";

function pendingRecord(
  current: IPlayerStat | undefined,
  value: number,
  puzzle: IPuzzleV1,
): IPlayerStat | undefined {
  if (value <= 0 || (current && value <= current.value)) {
    return current;
  }
  return { value, placeOverall: undefined, date: puzzle.date };
}

export function mergePendingPuzzleStats(
  current: IPlayerStats | undefined,
  puzzle: IPuzzleV1,
): IPlayerStats | undefined {
  if (!puzzle.played) {
    return current;
  }

  const stats: IPlayerStats = current
    ? { ...current, letters: current.letters.slice() }
    : {
        totalPlays: undefined,
        mostFoundWords: undefined,
        totalPoints: undefined,
        regularPoints: undefined,
        rarityPoints: undefined,
        letters: [],
      };
  const words = puzzle.foundWords.value;
  const regularPoints = puzzle.regularPoints.value ?? 0;
  const rarityPoints = puzzle.rarityPoints.value;

  stats.mostFoundWords = pendingRecord(stats.mostFoundWords, words.length, puzzle);
  stats.regularPoints = pendingRecord(stats.regularPoints, regularPoints, puzzle);
  stats.totalPoints = pendingRecord(
    stats.totalPoints,
    regularPoints + (rarityPoints ?? 0),
    puzzle,
  );
  if (rarityPoints !== undefined) {
    stats.rarityPoints = pendingRecord(stats.rarityPoints, rarityPoints, puzzle);
  }

  const wordsByLength = new Map<number, number>();
  for (const word of words) {
    wordsByLength.set(word.word.length, (wordsByLength.get(word.word.length) ?? 0) + 1);
  }
  for (const [length, count] of wordsByLength) {
    stats.letters[length] = pendingRecord(stats.letters[length], count, puzzle);
  }

  return stats;
}
